import { useNavigate } from "react-router-dom";

export default function CartMovedModal({ onClose }) {
  const navigate=useNavigate();
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="w-[265px]  h-[210px] md:h-[230px] rounded-[20px] bg-white shadow-lg text-center p-5 relative">
        <button onClick={onClose} className="absolute top-3 right-3 text-gray-500 text-lg md:text-xl xl:text-2xl font-bold">×</button>
        <div className="w-16 h-16 mx-auto mb-3 rounded-full bg-gradient-to-tr from-orange-400 to-pink-500 flex items-center justify-center">
          <span className="text-white text-2xl">🛒</span>
        </div>
        <p className="text-xs md:text-sm xl:text-base font-medium text-gray-800 mb-3">Item move to cart!<br />Please check your cart</p>
        <button className="mt-4 text-xs md:text-sm xl:text-base bg-[#A63F40] text-white px-4 py-2 rounded hover:bg-[#772627]"
        onClick={()=>{navigate("/cartpage");onClose();}}>Go To Cart</button>
      </div>
    </div>
  );
}
